module.exports = new __parcel__URL__("hdri_1_edited.6be4a7ac.hdr").toString();